module.exports = __webpack_public_path__ + "aa71b96fe51cab14f2722692575bee38.jpg";